import React from 'react'
import { graphql } from 'gatsby'
import clamp from 'clamp-js'
import Image from '../components/image'
import NavBanner from '../components/navBanner'
import { PAGES, navigateToId } from '../components/constants'
import ContentSections from '../components/contentSectionList'
import Footer from '../components/footer'
import { withMainContext } from '../components/menuContainer'
import '../styles/show-work.less'

class ShowTemplate extends React.Component {
  componentDidMount() {
    const { setSmallMenuRatioIfUnchanged } = this.props
    if (setSmallMenuRatioIfUnchanged) setSmallMenuRatioIfUnchanged()
    if (this._headerRef) clamp(this._headerRef, { clamp: 1 })
  }
  render() {
    const { data } = this.props 
    const { markdownRemark: info } = data
    const { frontmatter: content } = info
    const { contentSections, title, dates, institution, location } = content

    let infoSection = {
      title: 'Info',
      title_link: null,
      has_anchor: true,
      elementId: 'show-info-section',
      isInfo: true,
      content: { title, dates, institution, location }
    }

    if (contentSections.length == 0 || !contentSections[0].isInfo) {
      contentSections.unshift(infoSection)
    }

    return (
        <article className="show-content">
          <NavBanner to={PAGES.SHOWS}/>
  
          <section className="header-container">
            {/* <h4>{content.title} { contentSections.length > 0 && <> ・ <a className="direct-url" onClick={navigateToId('content-container')} href={`javascript:;`}>Info</a></> } </h4> */}
            <h4 ref={r => this._headerRef = r} style={{padding: '0 calc(1rem / 2) 0', lineHeight: '2.4'}}>{content.title}</h4>
            { contentSections && contentSections.length > 0 && (
              <ul>
                { contentSections.map(c => (<li><a onClick={navigateToId(c.elementId)} href={`javascript:;`}>{c.title}</a></li>)) }
              </ul>
            )}
          </section>
  
          <section className="show-image-list">
            { content.images.map(i => {
              return (
              <Image 
                imageInfo={i.imageInfo} 
                credits={i.credits} 
                imgSharp={i.image ? i.image.childImageSharp : null}   
                publicURL={i.image ? i.image.publicURL : ''}             
                marginBottom={true}
              />)
            })}
          </section>
          
          <section className="content-container" id="content-container">
            <ContentSections sections={contentSections}/>
          </section>
          
          <Footer lastEdited={info.frontmatter.lastEdited}/>
        </article>
    )  
  }
}

export default withMainContext((context, props) => ({
  setSmallMenuRatioIfUnchanged: context.action.setSmallMenuRatioIfUnchanged
}))(ShowTemplate)

export const showQuery = graphql`
  query ShowPage($path: String!) {
    markdownRemark(fields: { permalink: { eq: $path } } ) {
      fields {
        permalink
        mediaPermalink
      }
      html
      frontmatter {
        lastEdited
        contentSections {
          content
          has_anchor
          title
          title_link
          elementId
        }
        images {
          imageInfo {
            workTitle
            additionalInfo
          }
          credits
          image {
            childImageSharp {
              fluid(quality: 75, maxHeight: 1000) {
                ...GatsbyImageSharpFluid
              }
            }
            publicURL
          }
        }
        dates
        institution
        location
        title
        layout
      }
    }
  }
`